module.exports = __webpack_public_path__ + "static/img/goods-detail.561f3ac9.svg";